// ToyCommandAnimationPanel.js
'use strict';
import { connect } from 'react-redux';

import ToyCommandAnimationPanel from '../component/ToyCommandAnimationPanel.jsx';
import getListData from '../selector/getListData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import { karaokeType } from '../resource/goalConstants.js';

const mapStateToProps = (state, { streamId, isToy }) => {
  const status = getPrivateShowStatus(state, streamId);

  const karaokeIds = getListData(
    state,
    [
      'liveStream',
      streamId,
      'karaoke',
      isToy ? karaokeType.TOY_DEVICE : karaokeType.DEFAULT,
    ],
    'itemIds'
  );

  const itemIds = getListData(
    state,
    [
      'liveStream',
      streamId,
      'goal',
      isToy ? karaokeType.TOY_DEVICE : karaokeType.DEFAULT,
    ],
    'itemIds'
  );

  return {
    itemIds,
    karaokeIds,
    isToy,
    status,
  };
};

export default connect(mapStateToProps)(ToyCommandAnimationPanel);
